<template>
  <section class="sales product-listing">
    <grid v-for="(item, index) in categories"
          :categoryIndex="index"
          :key="item.id"
          :category="item" />
  </section>
</template>
<script>
  import { mapGetters } from 'vuex'
  import Grid from 'theme/components/theme/blocks/Home/Grid'

  export default {
    name: 'CategoryGrid',
    components: {
      Grid
    },
    computed: {
      ...mapGetters({
        categories: 'category/getCategories',
        currentPartnerCode: 'partners/getCurrentPartnerCode'
      })
    }
  }
</script>
<style lang="scss">
  .sales.product-listing {
    padding-top: 0;
    padding-bottom: 24px;
    background-color: #ffffff;
    .VueCarousel-navigation button{
      z-index: 1;
    }
  }
  .half-circle-spinner, .half-circle-spinner * {
    box-sizing: border-box;
  }

  .half-circle-spinner {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    position: relative;
    margin: 25px auto 0;
  }

  .half-circle-spinner .circle {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: calc(60px / 10) solid transparent;
  }

  .half-circle-spinner .circle.circle-1 {
    border-top-color: #349614;
    animation: half-circle-spinner-animation 1s infinite;
  }

  .half-circle-spinner .circle.circle-2 {
    border-bottom-color: #349614;
    animation: half-circle-spinner-animation 1s infinite alternate;
  }

  @keyframes half-circle-spinner-animation {
    0% {
      transform: rotate(0deg);

    }
    100%{
      transform: rotate(360deg);
    }
  }
  .perload-text{
    width: 100px;
    height: 22px;
    opacity: 0.6;
  }
  .perload-text-2 {
    width: 50px;
    height: 16px;
    background-color: #11bb2e;
    opacity: 0.6;
  }
</style>
